import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68a7b9d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"90vh"} }
const _hoisted_2 = { style: {"height":"0.5vh","background-color":"#ccc"} }
const _hoisted_3 = { class: "p-mt-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"20px"},
  class: "pi pi-globe"
}, null, -1))
const _hoisted_5 = { class: "p-mx-1" }
const _hoisted_6 = { class: "p-mx-1" }
const _hoisted_7 = { class: "p-mx-1" }
const _hoisted_8 = {
  class: "p-col-12",
  style: {"height":"8vh"}
}
const _hoisted_9 = { class: "p-grid" }
const _hoisted_10 = { class: "p-col-9 p-pr-0" }
const _hoisted_11 = { class: "p-fluid" }
const _hoisted_12 = { class: "p-mr-1" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" NAME : ")
const _hoisted_14 = { class: "pull-right" }
const _hoisted_15 = { class: "p-mx-1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" EXPIRY DATE : ")
const _hoisted_17 = { class: "pull-right" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" GENERIC : ")
const _hoisted_19 = { class: "pull-right" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" BATCH NO : ")
const _hoisted_21 = { class: "pull-right" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Total Units : ")
const _hoisted_23 = { class: "pull-right" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" MRP : ")
const _hoisted_25 = { class: "pull-right" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Pack Price : ")
const _hoisted_27 = { class: "pull-right" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Purchase Price : ")
const _hoisted_29 = { class: "pull-right" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Brand Name : ")
const _hoisted_31 = { class: "pull-right" }
const _hoisted_32 = { class: "p-col-3" }
const _hoisted_33 = { class: "p-fluid" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" TITLE : ")
const _hoisted_35 = { class: "pull-right" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Email : ")
const _hoisted_37 = { class: "pull-right" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Contact : ")
const _hoisted_39 = { class: "pull-right" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Account Type : ")
const _hoisted_41 = { class: "pull-right" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { class: "p-error" }
const _hoisted_44 = {
  key: 1,
  class: "p-error"
}
const _hoisted_45 = {
  class: "p-col-12 pos-table",
  style: {"height":"64vh","background-color":"#f9f9f9"}
}
const _hoisted_46 = { class: "table table-stiped table-bordered p-m-0" }
const _hoisted_47 = { class: "pos-heading" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { style: {"width":"8rem"} }, "Batch No", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Unit Qty", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Free Qty", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Sup Bonus", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "P.Disc (%)", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "After Disc", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cus Disc %", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Expiry Date", -1))
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = { key: 2 }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "REMOVE", -1))
const _hoisted_60 = { class: "table-row" }
const _hoisted_61 = { class: "p-inputgroup" }
const _hoisted_62 = { class: "p-inputgroup" }
const _hoisted_63 = { class: "p-inputgroup" }
const _hoisted_64 = { class: "p-inputgroup" }
const _hoisted_65 = { class: "p-inputgroup" }
const _hoisted_66 = { class: "p-inputgroup" }
const _hoisted_67 = { class: "p-inputgroup" }
const _hoisted_68 = { class: "p-inputgroup" }
const _hoisted_69 = { class: "p-inputgroup" }
const _hoisted_70 = { class: "p-inputgroup" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "p-inputgroup" }
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "p-inputgroup" }
const _hoisted_75 = { key: 2 }
const _hoisted_76 = { class: "p-inputgroup" }
const _hoisted_77 = { class: "p-text-center" }
const _hoisted_78 = { class: "p-text-center" }
const _hoisted_79 = {
  key: 0,
  class: "item-detail-row"
}
const _hoisted_80 = ["colspan"]
const _hoisted_81 = { class: "p-mr-1" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" PRODUCT NAME: ")
const _hoisted_83 = { style: {"color":"#fff","background-color":"#c00"} }
const _hoisted_84 = { class: "p-mr-1" }
const _hoisted_85 = /*#__PURE__*/_createTextVNode(" GENERIC: ")
const _hoisted_86 = { style: {"color":"#fff","background-color":"#c00"} }
const _hoisted_87 = { class: "p-mx-1" }
const _hoisted_88 = { class: "p-mx-1" }
const _hoisted_89 = { class: "p-mx-1" }
const _hoisted_90 = { class: "p-mx-1" }
const _hoisted_91 = {
  class: "p-col-12",
  style: {"height":"10vh","background-color":"#eee"}
}
const _hoisted_92 = { class: "p-grid" }
const _hoisted_93 = { class: "p-col-9 p-pr-0" }
const _hoisted_94 = { class: "p-fluid" }
const _hoisted_95 = { class: "p-col-3" }
const _hoisted_96 = { class: "p-fluid" }
const _hoisted_97 = {
  style: {"height":"10vh"},
  class: "p-grid p-m-0 p-p-0"
}
const _hoisted_98 = { class: "set-bottom-amt p-col" }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("Total QTY ")
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_101 = { class: "set-bottom-amt p-col" }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("Total Gross ")
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_104 = { class: "set-bottom-amt p-col" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Total Disc ")
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_107 = {
  key: 0,
  class: "set-bottom-amt p-col"
}
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_109 = {
  key: 1,
  class: "set-bottom-amt p-col"
}
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_111 = {
  key: 2,
  class: "set-bottom-amt p-col"
}
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_113 = { class: "set-bottom-amt p-col" }
const _hoisted_114 = /*#__PURE__*/_createTextVNode("Net Total ")
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_116 = { class: "confirmation-content" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-search p-mr-3",
  style: {"font-size":"2rem"}
}, null, -1))
const _hoisted_118 = { class: "p-fluid" }
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "search_receipt" }, " Enter Receipt No ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_PaymentScreen = _resolveComponent("PaymentScreen")!
  const _component_ProfilerDialog = _resolveComponent("ProfilerDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.progressBar)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                style: {"height":"0.2em"}
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Toolbar, { style: {"height":"7.5vh"} }, {
          start: _withCtx(() => [
            _createElementVNode("h5", _hoisted_3, [
              _createElementVNode("b", null, [
                _hoisted_4,
                _createTextVNode(" " + _toDisplayString(_ctx.storeName), 1)
              ])
            ])
          ]),
          end: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Dropdown, {
                style: {"width":"15rem"},
                modelValue: _ctx.item.type,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.item.type) = $event)),
                options: _ctx.modeList,
                optionLabel: "label",
                optionValue: "value",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clearFreeUnit()))
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Button, {
                icon: "pi pi-plus",
                label: "New Profile",
                class: "p-button-success",
                onClick: _ctx.openProfileDialog
              }, null, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_Button, {
                icon: "pi pi-times",
                label: "Clear Screen",
                class: "p-button-danger",
                onClick: _ctx.clearAll
              }, null, 8, ["onClick"])
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[2] || (_cache[2] = ($event: any) => (_ctx.saveItem($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.itemScanBox,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.itemScanBox) = $event)),
                  suggestions: _ctx.itemList,
                  placeholder: " SCAN BARCODE OR SEARCH ITEMS",
                  onComplete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchItem($event))),
                  dropdown: false,
                  autoFocus: ""
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("b", _hoisted_14, _toDisplayString(slotProps.item.product_name.toUpperCase()), 1)
                      ]),
                      _createElementVNode("span", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("b", _hoisted_17, _toDisplayString(_ctx.formatExpiryDate(slotProps.item.expiry_date)), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, [
                        _hoisted_18,
                        _createElementVNode("b", _hoisted_19, _toDisplayString(slotProps.item.generic.toUpperCase()), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("small", null, [
                        _hoisted_20,
                        _createElementVNode("b", _hoisted_21, _toDisplayString(slotProps.item.batch_no), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_22,
                        _createElementVNode("b", _hoisted_23, _toDisplayString(slotProps.item.qty), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_24,
                        _createElementVNode("b", _hoisted_25, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.mrp), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_26,
                        _createElementVNode("b", _hoisted_27, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.sale_price), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_28,
                        _createElementVNode("b", _hoisted_29, _toDisplayString(_ctx.currency) + " " + _toDisplayString(slotProps.item.purchase_price), 1)
                      ]),
                      _createElementVNode("small", null, [
                        _hoisted_30,
                        _createElementVNode("b", _hoisted_31, _toDisplayString(slotProps.item.bName), 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_AutoComplete, {
                  delay: 1000,
                  minLength: 3,
                  onItemSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveProfile($event))),
                  scrollHeight: "500px",
                  modelValue: _ctx.v$.selectedProfile.$model,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.selectedProfile.$model) = $event)),
                  suggestions: _ctx.profilerList,
                  placeholder: "Search Profile",
                  onComplete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchProfiler($event))),
                  dropdown: false,
                  autoFocus: ""
                }, {
                  item: _withCtx((slotProps) => [
                    _createElementVNode("div", null, [
                      _hoisted_34,
                      _createElementVNode("b", _hoisted_35, _toDisplayString(slotProps.item.account_title.toUpperCase()), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_36,
                      _createElementVNode("span", _hoisted_37, _toDisplayString(slotProps.item.email_address), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_38,
                      _createElementVNode("span", _hoisted_39, _toDisplayString(slotProps.item.contact_no), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_40,
                      _createElementVNode("span", _hoisted_41, _toDisplayString(slotProps.item.account_type), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "suggestions"]),
                (_ctx.v$.selectedProfile.$error && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.selectedProfile.$errors, (error, index) => {
                        return (_openBlock(), _createElementBlock("span", {
                          id: "p-error",
                          key: index
                        }, [
                          _createElementVNode("small", _hoisted_43, _toDisplayString(error.$message), 1)
                        ]))
                      }), 128))
                    ]))
                  : (
                      (_ctx.v$.selectedProfile.$invalid && _ctx.submitted) ||
                      _ctx.v$.selectedProfile.$pending.$response
                    )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_ctx.v$.selectedProfile.required.$message.replace(
                        "Value",
                        "Profile"
                      )), 1))
                    : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("table", _hoisted_46, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_47, [
                _hoisted_48,
                _hoisted_49,
                _hoisted_50,
                _hoisted_51,
                _createElementVNode("th", null, "Purchase Price (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_52,
                _hoisted_53,
                _createElementVNode("th", null, "MRP PRICE (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_54,
                _hoisted_55,
                (_ctx.taxNames[0].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_56, _toDisplayString(_ctx.taxNames[0].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[1].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_57, _toDisplayString(_ctx.taxNames[1].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                (_ctx.taxNames[2].show)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_58, _toDisplayString(_ctx.taxNames[2].taxName) + " %", 1))
                  : _createCommentVNode("", true),
                _createElementVNode("th", null, "Subtotal (" + _toDisplayString(_ctx.currency) + ")", 1),
                _hoisted_59
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.savedItemList.slice().reverse(), (savedItem) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: savedItem }, [
                  _createElementVNode("tr", _hoisted_60, [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_61, [
                        _createVNode(_component_InputText, {
                          style: {"height":"30px"},
                          modelValue: savedItem.batchNo,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.batchNo) = $event),
                          class: "p-p-1"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          min: 1,
                          modelValue: savedItem.unit,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.unit) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_63, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          min: 1,
                          modelValue: savedItem.freeUnit,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.freeUnit) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          min: 1,
                          modelValue: savedItem.supplierBonus,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.supplierBonus) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_InputNumber, {
                          style: {"width":"2rem","height":"30px"},
                          min: 1,
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.purchasePrice,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.purchasePrice) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_66, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.itemDisc,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.itemDisc) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_67, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.purchaseAfterDisc,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.purchaseAfterDisc) = $event),
                          disabled: true,
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_InputNumber, {
                          style: {"width":"2rem","height":"30px"},
                          min: 1,
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.mrp,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.mrp) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_69, [
                        _createVNode(_component_InputNumber, {
                          useGrouping: false,
                          style: {"width":"2rem","height":"30px"},
                          minFractionDigits: 2,
                          maxFractionDigits: 2,
                          modelValue: savedItem.cusDisc,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.cusDisc) = $event),
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_Calendar, {
                          id: "expiryDate",
                          modelValue: savedItem.expiryDate,
                          "onUpdate:modelValue": ($event: any) => ((savedItem.expiryDate) = $event),
                          style: {"width":"2rem","height":"30px"},
                          selectionMode: "single",
                          dateFormat: "dd-mm-yy",
                          class: "p-p-0"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    (_ctx.taxNames[0].show)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_71, [
                          _createElementVNode("div", _hoisted_72, [
                            _createVNode(_component_InputNumber, {
                              useGrouping: false,
                              style: {"width":"2rem","height":"30px"},
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              modelValue: savedItem.tax1,
                              "onUpdate:modelValue": ($event: any) => ((savedItem.tax1) = $event),
                              class: "p-p-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.taxNames[1].show)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createVNode(_component_InputNumber, {
                              useGrouping: false,
                              style: {"width":"2rem","height":"30px"},
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              modelValue: savedItem.tax2,
                              "onUpdate:modelValue": ($event: any) => ((savedItem.tax2) = $event),
                              class: "p-p-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.taxNames[2].show)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_component_InputNumber, {
                              useGrouping: false,
                              style: {"width":"2rem","height":"30px"},
                              minFractionDigits: 2,
                              maxFractionDigits: 2,
                              modelValue: savedItem.tax3,
                              "onUpdate:modelValue": ($event: any) => ((savedItem.tax3) = $event),
                              class: "p-p-0"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_77, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.getTheSubtotal(savedItem)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_78, [
                      _createVNode(_component_Button, {
                        icon: "pi pi-minus",
                        class: "p-button-danger p-p-1",
                        onClick: ($event: any) => (_ctx.clearListItem(savedItem))
                      }, null, 8, ["onClick"])
                    ])
                  ]),
                  (savedItem.productID != 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_79, [
                        _createElementVNode("td", { colspan: _ctx.countTaxesLen }, [
                          _createElementVNode("span", _hoisted_81, [
                            _hoisted_82,
                            _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.limitString(savedItem.productName)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_84, [
                            _hoisted_85,
                            _createElementVNode("span", _hoisted_86, _toDisplayString(_ctx.limitString(savedItem.generic)), 1)
                          ]),
                          _createElementVNode("span", _hoisted_87, " SHEET SIZE : " + _toDisplayString(savedItem.sheetSize), 1),
                          _createElementVNode("span", _hoisted_88, " PACKSIZE : " + _toDisplayString(savedItem.packSize), 1),
                          _createElementVNode("span", _hoisted_89, " TOTAL UNITS : " + _toDisplayString(_ctx.fixDigits(savedItem.totalUnit)), 1),
                          _createElementVNode("span", _hoisted_90, " PACK PRICE : " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(savedItem.sellingPrice)), 1)
                        ], 8, _hoisted_80)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_91, [
          _createElementVNode("div", _hoisted_92, [
            _createElementVNode("div", _hoisted_93, [
              _createElementVNode("div", _hoisted_94, [
                _createVNode(_component_InputText, {
                  placeholder: "Receipt Description",
                  modelValue: _ctx.item.description,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.item.description) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createVNode(_component_InputText, {
                  placeholder: "Bill No",
                  modelValue: _ctx.item.billNo,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.item.billNo) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_97, [
        _createVNode(_component_Button, {
          class: "p-col p-button-success b-style",
          icon: "pi pi-home",
          label: "HOME",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.redirectHome()))
        }),
        _createElementVNode("span", _hoisted_98, [
          _hoisted_99,
          _hoisted_100,
          _createTextVNode(" # " + _toDisplayString(_ctx.savedItemList.length), 1)
        ]),
        _createElementVNode("span", _hoisted_101, [
          _hoisted_102,
          _hoisted_103,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalGross)), 1)
        ]),
        _createElementVNode("span", _hoisted_104, [
          _hoisted_105,
          _hoisted_106,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalDiscAmount)), 1)
        ]),
        (_ctx.taxNames[0].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_107, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[0].taxName) + " ", 1),
              _hoisted_108,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax1)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.taxNames[1].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_109, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[1].taxName) + " ", 1),
              _hoisted_110,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax2)), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.taxNames[2].show)
          ? (_openBlock(), _createElementBlock("span", _hoisted_111, [
              _createTextVNode("Total " + _toDisplayString(_ctx.taxNames[2].taxName) + " ", 1),
              _hoisted_112,
              _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.totalTax3)), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_113, [
          _hoisted_114,
          _hoisted_115,
          _createTextVNode(" " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.fixDigits(_ctx.netTotal)), 1)
        ]),
        _createVNode(_component_Button, {
          class: "p-col p-button-warning b-style",
          icon: "pi pi-arrow-right",
          label: "NEXT",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.openPaymentMethod(!_ctx.v$.$invalid))),
          disabled: _ctx.item.profileID == 0 || _ctx.netTotal <= 0
        }, null, 8, ["disabled"])
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.receiptDailog,
      "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.receiptDailog) = $event)),
      style: { width: '600px' },
      header: "Search Receipt",
      position: "top"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "No",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.refundReceiptDialog = false))
        }),
        _createVNode(_component_Button, {
          label: "Search",
          icon: "pi pi-search",
          class: "p-button-success",
          disabled: _ctx.item.searchReceiptNo == '',
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.fetchReceiptNo()))
        }, null, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_116, [
          _hoisted_117,
          _createElementVNode("div", _hoisted_118, [
            _hoisted_119,
            _createVNode(_component_InputText, {
              id: "search_receipt",
              autoFocus: "",
              modelValue: _ctx.item.searchReceiptNo,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item.searchReceiptNo) = $event)),
              placeholder: "e.g PUR-02502100000000"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_PaymentScreen, {
      receiptDetail: {
      dialogStatus: _ctx.paymentDialog,
      itemSource: _ctx.item.type,
      restriction: 'No',
      dialogTilte: _ctx.dialogTitle,
      customerID: this.item.profileID,
      customerName: this.state.selectedProfile,
      closeConfirmation: true,
    },
      onClosePaymentScreenEvent: _ctx.closePaymentScreen,
      onGetProceededPaymentsEvent: _ctx.getProceededPayments
    }, null, 8, ["receiptDetail", "onClosePaymentScreenEvent", "onGetProceededPaymentsEvent"]),
    _createVNode(_component_ProfilerDialog, {
      profilerDetail: {
      status: this.profileStatus,
      profilerID: 0,
      statusType: this.statusType,
      dialogTitle: this.dialogTitle,
      currentUserID: this.currentUserID,
    },
      onUpdateProfilerStatus: _ctx.updateProfilerStatus
    }, null, 8, ["profilerDetail", "onUpdateProfilerStatus"])
  ], 64))
}